var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-country-map-d3-container"},[_c('svg',{ref:"multi-country-map-d3"}),_c('div',{ref:"multi-country-map-d3-tooltip",staticClass:"tooltip-map"}),_c('div',{ref:"legends",staticClass:"legends"})])
}
var staticRenderFns = []

export { render, staticRenderFns }